<div class="scrollable-multiple-search-field-container">
  <ng-select
    style="width: 100%"
    [items]="filteredResult"
    [bindLabel]="labelKey"
    [placeholder]="searchPlaceHolder"
    [loading]="isLoading"
    loadingText="Loading..."
    [typeahead]="typeahead$"
    [clearable]="false"
    [multiple]="multiple"
    [closeOnSelect]="!multiple"
    [formControl]="ctrl"
    [ngClass]="{ 'hide-arrow': isClearIconVisible() }"
    (change)="onChange($event)"
    (scrollToEnd)="fetchData()"
    (blur)="selectSearchCtrl.markAsTouched()"
    >
    <!-- Collapsed display of selections: "First (+N others)" -->
    <ng-template ng-multi-label-tmp let-items="items">
      <div class="ng-value">
        {{ items[0] ? items[0][labelKey] : '' }}
        @if (items.length > 1) {
          <span class="example-additional-selection">
            (+{{ items.length - 1 }} {{ items.length === 2 ? 'other' : 'others' }})
          </span>
        }
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp>
      @if (!addNewOnNoEntriesFound) {
        <div class="ng-option disabled">
          {{ messageNoEntriesFound }}
        </div>
      }
      @if (addNewOnNoEntriesFound) {
        <div class="ng-option">
          <div class="add_customer_btn" (click)="createRecord()">
            <img src="../../../../../assets/img/add_customer_icon.svg" alt="" class="icon" width="20" height="20" />
            {{ addButtonLabel }}
          </div>
        </div>
      }
    </ng-template>
  </ng-select>
</div>

<!-- Clear Icon -->
@if (isClearIconVisible() && !disabled) {
  <div class="clear-icon">
    <i class="fa fa-times" (click)="clearInput()"></i>
  </div>
}

<!-- Error Message -->
@if (hasError()) {
  <div style="font-size: 0.875em; margin-top: -12px">
    <small class="text-danger"> This field is required </small>
  </div>
}
